<template>
  <div class="page">
    <div class="body">
      <div class="amount-card">
        <div class="amount-label">付款金额</div>
        <div class="amount-line">
          <span class="amount-symbol">¥</span>
          <span class="amount-value">{{ displayAmount }}</span>
        </div>
        <div v-if="remark" class="remark-text">{{ remark }}</div>
      </div>
      <div class="brand-wrap">
        <img class="brand-logo" src="https://agent.fskeeper.com/img/乘鱼掌柜（黑色字体）.png" alt="乘鱼掌柜" />
        <div class="brand-support">本支付由乘鱼掌柜提供支持</div>
        <div v-if="hint" class="hint">{{ hint }}</div>
        <div v-else-if="paid" class="done">支付成功</div>
      </div>
    </div>
    <div class="footer">
      <div class="pay" :class="{ disabled: !canPay }" @click="pay">{{ paid ? '已支付' : '确认支付' }}</div>
    </div>
    <div v-if="paying" class="mask">
      <div class="mask-box">处理中...</div>
    </div>
  </div>
</template>

<script>
import request from '@/http/request'

export default {
  data () {
    return {
      mchNo: '',
      appId: '',
      amount: '',
      remark: '',
      mchOrderNo: '',
      notifyUrl: '',
      exp: '',
      ticket: '',
      hint: '',
      paid: false,
      paying: false,
      alipayUrl: ''
    }
  },
  computed: {
    displayAmount () {
      const n = Number(this.amount)
      if (!n || n <= 0) return ''
      const fixed = n.toFixed(2)
      const parts = fixed.split('.')
      const left = parts[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return left + '.' + parts[1]
    },
    canPay () {
      return !!this.mchNo && !!this.appId && !!this.ticket && Number(this.amount) > 0 && !this.paying && !this.paid
    }
  },
  mounted () {
    document.title = '确认付款'
    const q = this.$route.query || {}
    this.mchNo = q.mchNo || ''
    this.appId = q.appId || ''
    this.amount = q.amount || ''
    this.remark = q.remark || ''
    this.mchOrderNo = q.mchOrderNo || ''
    this.notifyUrl = q.notifyUrl || ''
    this.exp = q.exp || ''
    this.ticket = q.ticket || ''
    if (!this.canPay) {
      this.hint = '请从商城订单进入'
      return
    }
    this.prepare()
  },
  methods: {
    openAlipay (url) {
      const text = String(url || '')
      if (/AlipayClient/i.test(navigator.userAgent || '')) {
        window.location.href = text
        return
      }
      const scheme = text.indexOf('qr.alipay.com') >= 0
        ? 'alipays://platformapi/startapp?saId=10000007&qrcode=' + encodeURIComponent(text)
        : text
      window.location.href = 'https://ds.alipay.com/?scheme=' + encodeURIComponent(scheme)
    },
    prepare () {
      this.paying = true
      this.hint = ''
      request.request({
        url: '/api/cashier/lite-ali-pay',
        method: 'POST',
        data: {
          mchNo: this.mchNo,
          appId: this.appId,
          amount: this.amount,
          mchOrderNo: this.mchOrderNo,
          remark: this.remark,
          notifyUrl: this.notifyUrl,
          exp: this.exp,
          ticket: this.ticket
        }
      }, true, false, false).then(data => {
        this.paying = false
        const url = data && data.url
        if (!url) {
          this.hint = '未返回支付宝跳转地址'
          return
        }
        this.alipayUrl = url
        if (/AlipayClient/i.test(navigator.userAgent || '')) {
          this.openAlipay(url)
        }
      }).catch(err => {
        this.paying = false
        const msg = (err && (err.msg || err.message)) || '下单失败'
        if (msg.indexOf('已支付') >= 0) {
          this.paid = true
          return
        }
        this.hint = msg
      })
    },
    pay () {
      if (!this.canPay) return
      if (!this.alipayUrl) {
        this.hint = '正在准备付款，请稍候再点'
        this.prepare()
        return
      }
      this.openAlipay(this.alipayUrl)
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}
.body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 0;
}
.amount-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 18px 16px;
  text-align: left;
}
.amount-label {
  color: #8b919a;
  font-size: 13px;
}
.amount-line {
  display: flex;
  align-items: baseline;
  margin-top: 10px;
  color: #1a1a1a;
}
.amount-symbol {
  font-size: 24px;
  font-weight: 700;
  margin-right: 4px;
}
.amount-value {
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.5px;
}
.remark-text {
  margin-top: 14px;
  color: #9aa0a8;
  font-size: 13px;
}
.brand-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 28px;
}
.brand-logo {
  width: 140px;
  height: auto;
}
.brand-support {
  margin-top: 6px;
  font-size: 12px;
  color: #b0b6be;
}
.hint, .done {
  margin-top: 14px;
  font-size: 13px;
  text-align: center;
}
.hint { color: #e65c5c; }
.done { color: #07c160; font-size: 14px; }
.footer {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
}
.pay {
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: #1677ff;
  color: #fff;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 600;
}
.pay.disabled {
  opacity: 0.55;
}
.mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mask-box {
  background: #fff;
  border-radius: 8px;
  padding: 18px 28px;
  font-size: 14px;
  color: #1f2329;
}
</style>
